import { rpx } from 'client/lib/rpx-client';
import type { LoadedProps } from '@components/router';

export async function load() {
  const [brands, schemes] = await Promise.all([
    rpx.branding.getBrands(),
    rpx.branding.getFontsAndColors(),
  ]);
  return { ...schemes, brands };
}

export type Props = LoadedProps<typeof load>;
export type Data = Props['state'];
export type LoginLayoutType = 'centered' | 'split';
export type Brand = Data['brands'][0];
